<script setup lang="ts">
const paginationContext = usePaginationContext();

defineProps<{
  ariaLabel?: string;
}>();
</script>

<template>
  <PaginationButton
    :disabled="paginationContext.isLastDisabled.value"
    :aria-label="ariaLabel ?? $t('Pagination.Aria.LastPageButton')"
    :on-click="paginationContext.lastPage"
  >
    <BaseIcon
      name="last"
      prefix="pagination"
    />
  </PaginationButton>
</template>
